import { Button, Card, CardBody, CardHeader, Spinner, Switch } from "@heroui/react"
import { MoonIcon, SparklesIcon, SunIcon } from "@heroicons/react/24/outline"
import PropTypes from 'prop-types'

const Theme = ({ handleSave, handleUpdate, isDirty, isLoading, isSaving, logoBackground }) => {
  const handleUpdateLogoBackground = (value) => {
    const color = value ? "#FFFFFF" : "#000000"
    handleUpdate('logo_background_color', color)
  }

  return (
    <Card className="mt-3">
      <CardHeader className="justify-between text-white bg-indigo-700">
        <div className="flex items-center">
          <SparklesIcon className="mr-2 w-14 h-14" />
          <div className="flex flex-col mr-8">
            <h1 className="text-lg font-semibold">Themes</h1>
            <p className="text-sm">Styling site options.</p>
          </div>
        </div>

        <Button color="success" isDisabled={!isDirty || isLoading} isLoading={isSaving} className="font-semibold text-white" onPress={() => handleSave()}>Save</Button>
      </CardHeader>

      <CardBody>
        <div className="px-4 pb-3">
          <div>
            <h3 className="font-semibold">Logo Background</h3>
            
            <div className="flex items-center justify-between">
              <p className="text-content2-foreground">
                Background color for the logo on the login page. You may wish to change the default of "light" if your logo has a transparent background and white text that will not be visible on a light background.
              </p>

              {isLoading && <Spinner className="ml-8" />}

              {!isLoading && (
                <Switch
                  className="ml-8"
                  color="success"
                  isSelected={logoBackground === "#FFFFFF"} 
                  endContent={<MoonIcon />}
                  startContent={<SunIcon />}
                  onValueChange={(value) => handleUpdateLogoBackground(value)}
                />
              )}
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

Theme.propTypes = {
  handleSave: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  isDirty: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  logoBackground: PropTypes.string.isRequired
}

export default Theme